import * as React from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';
import { CustomerPermission } from '../../../../../../../../models/customers';

interface Props {
  onCancel: () => void;
  onSubmit: (data) => void;
  customerPermission?: CustomerPermission;
}

const CustomerPermissionSchema = Yup.object().shape({
  username: Yup.string().required('Required'),
  password: Yup.string().required('Required'),
});

export function CustomerPermissionForm(props: Props) {
  const { customerPermission, onSubmit, onCancel } = props;
  const isCustomerPermissionExist = typeof customerPermission !== 'undefined';

  const customerPermissionForm = {
    username: isCustomerPermissionExist ? customerPermission.username : '',
    password: isCustomerPermissionExist ? customerPermission.password : '',
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Formik
            initialValues={customerPermissionForm}
            validationSchema={CustomerPermissionSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit }) => (
              <Form>
                <div className="form-group form-check">
                  <div className="form-group">
                    <label>Username</label>
                    <Field name="username" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="username" />
                  </div>

                  <div className="form-group">
                    <label>Password</label>
                    <Field name="password" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="password" />
                  </div>

                  <Button
                    onClick={onCancel}
                    text={'Cancel'}
                    customClass={'btn btn-primary mt-3 mb-3 mr-3 btn-secondary'}
                  />
                  <Button
                    onClick={handleSubmit}
                    text={'Save'}
                    customClass={'mt-3 mb-3 btn btn-primary'}
                    type={'submit'}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
